import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const LoginPage = lazy(() => import('../pages/login/page'));
const StoreManagerPage = lazy(() => import('../pages/manager/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/manager',
    element: <StoreManagerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
